import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import { useSessionContext } from '../../../contexts/SessionContext';



export default function LoadListListItemProduct(props){
    //console.debug("RTS Break LoadListListItemProductDetail");

    const {sessionCustomer} = useSessionContext();
    
    return (
        props.data.curAliasName == null
        ?
            <>
            <Typography variant="h6" sx={{color:"Red"}}>No Product Information Available</Typography>
            </> 
        :
            props.data.soldToCustomerIdGuid === sessionCustomer.customer.idGuid
            ?
                <>
                <Stack>
                    <>
                    <Tooltip title={props.data.curProductIdSap}>
                        
                        <Typography variant="h6" >
                            {props.data.curSoldToAliasName}
                        </Typography>
                    </Tooltip>
                    <Typography variant="caption" >
                        {props.data.curSoldToAliasNumber}
                    </Typography>
                    </>                                    
                </Stack>
                </>
            :
                <>
                <Stack>
                    <>
                    <Tooltip title={props.data.curProductIdSap}>
                        
                        <Typography variant="h6" >
                            {props.data.curAliasName}
                        </Typography>
                    </Tooltip>
                    <Typography variant="caption" >
                        {props.data.curAliasNumber}
                    </Typography>
                    </>                                    
                </Stack>
                </>
    );   
}

